module.exports = __webpack_public_path__ + "img/02.d5cf7a49.png";